import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { fetchApiServices } from "../../api/endpoint";
import Loader from "../../components/loader";
import Table from "../../components/table";
import axios from "axios";
import AddMore from "./addMore";
import { addNewApiService } from "../../api/endpoint";
import toast from "react-hot-toast";
import EditModal from "./editModal";
import { FaRegEdit } from "react-icons/fa";

const serviceTypes = {
  PAYMENT_GATEWAY: "Payment Gateway",
  OTP_SERVICE: "OTP Service",
  MAP_SERVICE: "Map Service",
};

const Api = () => {
  const [services, setServices] = useState();
  const [loading, setLoading] = useState(false);
  const [isAddMoreOpen, setIsAddMoreOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedApi, setSelectedApi] = useState("");
  const [selectedApiId, setSelectedApiId] = useState("");
  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    getAllApiServices();
  }, []);

  const getAllApiServices = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchApiServices, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      setServices(response?.data);
    } catch (error) {
      console.error("Error fetching api services", error);
    } finally {
      setLoading(false);
    }
  };

  const getActionButtons = (service) => {
    return (
      <div className="d-flex align-items-center">
        <div className="form-check form-switch mb-0 mt-1 me-1">
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked={service?.active}
            onChange={(e) => e.preventDefault()}
          />
        </div>
        <button
          className="btn p-0"
          onClick={() => {
            setSelectedApi(service);
            setSelectedApiId(service?.id)
            setIsEditOpen(true);
          }}
        >
          <FaRegEdit size={20} />
        </button>
      </div>
    );
  };

  const addNewService = async (service, type) => {
    try {
      setLoading(true);
      if (type == "edit") {
        const response = await axios.post(addNewApiService, service, {
          params: { id: selectedApiId },
          headers: { Authorization: `Bearer ${auth}` },
        });
      } else {
        const response = await axios.post(addNewApiService, service, {
          headers: { Authorization: `Bearer ${auth}` },
        });
      }
      getAllApiServices();
      toast.success(
        `${
          type == "edit"
            ? "Service updated succesfully"
            : "Service added successfully"
        }`
      );
    } catch (error) {
      toast.error("Error adding service");
      toast.error(
        `${type == "edit" ? "Error updating service" : "Error adding service"}`
      );
    } finally {
      setLoading(false);
    }
  };

  const headings = [
    // { name: "ID", fieldName: "id", isSortable: true, sortKey: "none" },
    { name: "Name", fieldName: "name", isSortable: true, sortKey: "none" },
    {
      name: "Type",
      fieldName: "type",
      isSortable: true,
      sortKey: "none",
    },
    {
      name: "Status",
      fieldName: "status",
      isSortable: false,
      sortKey: "none",
    },
  ];

  const tableRows = services?.map((service) => ({
    id: service?.id,
    name: service?.serviceName,
    type: serviceTypes[service?.serviceType],
    status: getActionButtons(service),
  }));

  return (
    <div className="px-md-2 px-1 py-md-2 py-1">
      {/* <h2>API Management</h2> */}
      <Table
        headings={headings}
        data={tableRows}
        addBtnText="+ Add"
        addCallback={() => setIsAddMoreOpen(true)}
        card={true}
        pageTitle="API Management"
      />
      <AddMore
        isAddMoreOpen={isAddMoreOpen}
        closeAddMoreModal={() => setIsAddMoreOpen(false)}
        handleAddService={addNewService}
      />
      <EditModal
        isAddMoreOpen={isEditOpen}
        closeAddMoreModal={() => setIsEditOpen(false)}
        handleAddService={addNewService}
        selectedApi={selectedApi}
      />
      {loading && <Loader />}
    </div>
  );
};

export default Api;
